module.exports = __webpack_public_path__ + "static/media/self.b3054460.jpg";